import React from "react";

function W1() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="326"
      height="30"
      fill="none"
      viewBox="0 0 326 30"
    >
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M129.796 1.65H0V.84h130.132l27.991 27.99H325.9v.811H157.787l-27.991-27.99z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}

export default W1;